<template>
  <CModal :title="title" :color="color" size="lg" :show.sync="showModal">
    <CForm>
      <!-- === AJUSTE MANUAL === -->
      <CRow>
        <CCol md="3">
          <CSelect label="Acción" :value.sync="$v.form.action.$model" :options="actionsOptions" />
        </CCol>
        <CCol md="3">
          <CSelect label="Tipo de Puntos" :value.sync="$v.form.type.$model" :options="typesOptions" />
        </CCol>
        <CCol md="3">
          <CInput label="Puntos" :lazy="false" :value.sync="$v.form.points.$model" :isValid="checkIfValid('points')"
            placeholder="500" autocomplete="given-points"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
        <CCol md="3">
          <CSelect label="Aprobar" :value.sync="$v.form.is_active.$model" :options="activeOptions" />
        </CCol>
      </CRow>
      <CRow style="margin-top: 10px;">
        <CCol md="12">
          <CInput label="Descripción" :lazy="false" :value.sync="$v.form.description.$model"
            :isValid="checkIfValid('description')" placeholder="Escribe una descripción..."
            autocomplete="given-description"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>

      <CRow class="mt-3">
        <CCol class="text-right">
          <CButton @click="store" color="info">
            Guardar Ajuste
          </CButton>
        </CCol>
      </CRow>

      <!-- === TOTALES === -->
      <CRow class="mt-3">
        <CCol class="d-flex flex-column">
          <strong>Totales actuales (Real / Aprob.):</strong>
          <div class="text-muted" style="font-size:13px;">
            Eventos: {{ totals.real.event_points }} / {{ totals.approved.event_points }} |
            Tarjeta: {{ totals.real.card_points }} / {{ totals.approved.card_points }} |
            Regalo: {{ totals.real.gift_points }} / {{ totals.approved.gift_points }} |
            Monedero: {{ totals.real.wallet_points }} / {{ totals.approved.wallet_points }}
          </div>
        </CCol>
      </CRow>

      <!-- === HISTORIAL === -->
      <CRow class="mt-3">
        <CCol>
          <CDataTable :items="points" :fields="fields" small bordered :noItemsView="{
            noResults: 'No se encontraron puntos',
            noItems: 'No hay puntos registrados'
          }">
            <template #date="{ item }">
              <td style="font-size: 12px;">
                {{ item.date | date }}
              </td>
            </template>
            <template #type="{ item }">
              <td style="font-size: 12px;">
                {{ typeLabels[item.type] || item.type }}
              </td>
            </template>
            <template #points="{ item }">
              <td :class="item.points > 0 ? 'text-success' : 'text-danger'" style="font-size: 12px;">
                {{ item.points }}
              </td>
            </template>
            <template #description="{ item }">
              <td style="font-size: 12px;">
                {{ item.description }}
              </td>
            </template>
            <template #status="{ item }">
              <td style="font-size: 12px;">
                <span v-if="item.is_active" class="text-success" style="font-size: 12px;">Aprob.</span>
                <span v-else class="text-danger" style="font-size: 12px;">Inactivo</span>
              </td>
            </template>
            <template #challenge_type="{ item }">
              <td style="font-size: 12px;">
                <span v-if="item.challenge_type === 'manual'" class="text-info" style="font-size: 12px;">Manual</span>
                <span v-else-if="item.challenge_type === 'bought'" class="text-dark" style="font-size: 12px;">Canje</span>
                <span v-else class="text-muted" style="font-size: 12px;">Concurso</span>
              </td>
            </template>
            <template #actions="{ item }">
              <td class="text-center" style="font-size: 12px;">
                <CButton v-if="item.challenge_type === 'manual'" color="danger" size="sm" @click="deleteModal(item)">
                  Eliminar
                </CButton>
                <span v-else class="text-muted">-</span>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cerrar</CButton>
    </template>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CModal>

</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import ws_suppliers from '../../services/suppliers';
import ws_managers from '../../services/managers';
import ws_executives from '../../services/executives';
import store from '../../store';
import DeleteModal from '../global/DeleteModal.vue'

export default {
  name: 'PointsModal',
  data() {
    return {
      showModal: false,
      title: 'Puntos de los Participantes',
      entityType: null,
      form: {
        id: null,
        action: 'add',
        type: 'event_points',
        points: '',
        description: '',
        is_active: 1
      },
      points: [],
      color: 'info',
      totals: {
        real: {
          event_points: 0,
          card_points: 0,
          gift_points: 0,
          wallet_points: 0
        },
        approved: {
          event_points: 0,
          card_points: 0,
          gift_points: 0,
          wallet_points: 0
        }
      },
      fields: [
        { key: 'date', label: 'Fecha', _style: 'font-size: 12px;' },
        { key: 'type', label: 'Tipo', _style: 'font-size: 12px;' },
        { key: 'points', label: 'Puntos', _style: 'font-size: 12px;' },
        { key: 'description', label: 'Descripción', _style: 'font-size: 12px;' },
        { key: 'challenge_type', label: 'Origen', _style: 'font-size: 12px;' },
        { key: 'status', label: 'Estado', _style: 'font-size: 12px;' },
        { key: 'actions', label: 'Acción', _style: 'font-size: 12px;' }
      ],
      activeOptions: [{ label: "Si", value: 1 }, { label: "No", value: 0 }],
      actionsOptions: [
        { label: 'Otorgar', value: 'add' },
        { label: 'Quitar', value: 'subtract' }
      ],
      typesOptions: [
        { label: 'Eventos', value: 'event_points' },
        { label: 'Tarjeta', value: 'card_points' },
        { label: 'Regalo', value: 'gift_points' },
        { label: 'Monedero', value: 'wallet_points' }
      ],
      typeLabels: {
        event_points: 'Eventos',
        card_points: 'Tarjeta',
        gift_points: 'Regalo',
        wallet_points: 'Monedero'
      }
    }
  },
  components: { DeleteModal },
  methods: {
    deleteModal(item) {
      this.$refs.deleteModal.show("Eliminar Puntos", item.id, item.description);
    },
    async deleteProcess(id) {
      this.loading();
      let response;
      if(this.entityType === 'suppliers') {
        response = await ws_suppliers.deleteRedeemablePoint({ id: id });
      } else if(this.entityType === 'managers') {
        response = await ws_managers.deleteRedeemablePoint({ id: id });
      } else if(this.entityType === 'gerentes') {
        response = await ws_executives.deleteRedeemablePoint({ id: id });
      }

      if (response.type == "success") {
        if (this.entityType === 'suppliers') {
          this.$emit("refreshSuppliers");
        } else if (this.entityType === 'managers') {
          this.$emit("refreshManagers");
        } else if (this.entityType === 'gerentes') {
          this.$emit("refreshGerentes");
        }
        await this.getHistoryPoints();
        this.loaded();
      }

      this.showToast(response.type, response.message);
    },
    async updatePointsModal(item,entityType) {
      this.showModal = true;
      this.title = `Puntos de: ${item.code}-${item.name}`;
      this.form.id = item.id;
      this.form.action = 'add';
      this.form.type = 'event_points';
      this.form.points = '';
      this.form.description = '';
      this.form.is_active = 1;
      this.entityType = entityType;

      await this.getHistoryPoints();
    },
    async getHistoryPoints() {
      let res;
      if (this.entityType === 'suppliers') {
        res = await ws_suppliers.getRedeemablePointsHistory(this.form.id);
      } else if (this.entityType === 'managers') {
        res = await ws_managers.getRedeemablePointsHistory(this.form.id);
      } else if (this.entityType === 'gerentes') {
        res = await ws_executives.getRedeemablePointsHistory(this.form.id);
      }
      if (res.type === 'success') {
        this.points = res.data.points;
        this.totals = res.data.totals;
      }
    },
    async store() {      
      this.$v.$touch()
      if (!this.isValid) return

      this.loading();
      let res;
      if (this.entityType === 'suppliers') {
        res = await ws_suppliers.updatePoints(this.form);
      } else if (this.entityType === 'managers') {
        res = await ws_managers.updatePoints(this.form);        
      } else if (this.entityType === 'gerentes') {
        res = await ws_executives.updatePoints(this.form);
      }
      if (res.type == "success") {        
        await this.getHistoryPoints();
        this.loaded();
        if(this.entityType === 'suppliers') {
          this.$emit("refreshSuppliers");
        } else if(this.entityType === 'managers') {
          this.$emit("refreshManagers");
        } else if(this.entityType === 'gerentes') {
          this.$emit("refreshGerentes");
        }
      }
      this.loaded();

      this.showToast(res.type, res.message);
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
    closeModal() {
      this.showModal = false
      this.entityType = null;
      this.points = [];
      this.totals = {
        real: {
          event_points: 0,
          card_points: 0,
          gift_points: 0,
          wallet_points: 0
        },
        approved: {
          event_points: 0,
          card_points: 0,
          gift_points: 0,
          wallet_points: 0
        }
      };
      this.$v.$reset()
    },
    checkIfValid(field) {
      const f = this.$v.form[field]
      return f.$dirty ? !f.$invalid : null
    }
  },
  validations: {
    form: {
      action: { required },
      type: { required },
      points: { required },
      description: { required },
      is_active: { required }
    }
  },
  mixins: [validationMixin],
  computed: {
    isValid() {
      return !this.$v.form.$invalid
    }
  }
}
</script>
